import { cB as e, cM as i, c as t } from "../../../_utils/cssr/index.js";
const r = e("icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
`, [i("color-transition", {
  transition: "color .3s var(--n-bezier)"
}), i("depth", {
  color: "var(--n-color)"
}, [t("svg", {
  opacity: "var(--n-opacity)",
  transition: "opacity .3s var(--n-bezier)"
})]), t("svg", {
  height: "1em",
  width: "1em"
})]);
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/icon/src/styles/index.cssr.js
// module id = 1650
// module chunks = 41